
import { Component, Vue, Prop } from 'vue-property-decorator';

import moment from 'moment';
import defaultColors from '@/colors';
moment.locale('es');

@Component({
  components: {
    DoughnutGraph: () => import('@/components/DoughnutGraph.vue'),
    LineChart: () => import('@/components/LineChart.vue'),
    BarGraph: () => import('@/components/BarGraph.vue'),
    Slick: () => import('vue-slick'),
  },
  computed: {},
  filters: {},
  watch: {
    GraphsData(newVal, oldVal) {
      (this as any).initGraphs(newVal);
    },
  },
})
export default class RequestsGraphs extends Vue {
  @Prop(Object) readonly GraphsData;
  @Prop(Function) readonly seeMoreRequestsOperations;
  @Prop(Function) readonly requestsFilters;
  showMoreRequestsGraphs: boolean = false;
  showMoreLabel: string = 'Ver reportes de clientes y ramos';
  iconExpanded: string = require('@/assets/ico-expand.svg');
  iconCollapsed: string = require('@/assets/ico-collapse.svg');
  databoxes: any = {
    requestsState: {
      isExpanded: false,
      svgPath: this.iconExpanded,
    },
    approvedPerClient: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    originalGrossAonPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    originalGrossAonPerClient: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    approvedPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    requestsOarPerBusiness: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    requestsOarPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    requestsCountPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
  };
  data: any = {
    approvedPerClient: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    originalGrossAonPerClient: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    originalGrossAonPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    requestsOarPerBusiness: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    requestsOarPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    requestsCountPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    approvedPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    requestsState: {
      labels: [],
      datasets: {
        backgroundColor: ['#32AE80', '#F3C911', '#DC5A57'],
        data: [],
      },
    },
    lastOperations: [],
  };
  ready: boolean = true;
  currencies: any = [];
  dates: any = [];
  requestsGraphFilters: any = {
    requestsPerBusiness: {
      currency: 1,
      validity: 1,
    },
    requestsPerBranch: {
      currency: 1,
      validity: 1,
    },
    countRequestsPerBranch: {
      currency: 1,
      validity: 1,
    },
  };

  async mounted() {
    await this.initGraphs(this.GraphsData);
  }

  resetData() {
    this.ready = false;
    this.data.approvedPerClient = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.originalGrossAonPerClient = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.originalGrossAonPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.requestsOarPerBusiness = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.requestsOarPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.requestsCountPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.approvedPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.requestsState = {
      labels: [],
      datasets: {
        backgroundColor: ['#32AE80', '#F3C911', '#DC5A57'],
        data: [],
      },
    };
    this.data.lastOperations = [];
    this.$nextTick(() => {
      this.ready = true;
    });
  }

  async initGraphs(newVal) {
    if (!newVal) return;

    let i = 0;
    newVal.requestsApprovedPerClient.forEach((element) => {
      if (this.databoxes.approvedPerClient.limit !== -1)
        if (i >= this.databoxes.approvedPerClient.limit) return;
      this.data.approvedPerClient.labels.push(
        element.subscriptor && element.subscriptor.companies.name
      );
      this.data.approvedPerClient.datasets.data.push(element.approved);
      i++;
    });

    i = 0;
    newVal.requestsApprovedPerBranch.forEach((element) => {
      if (this.databoxes.approvedPerBranch.limit !== -1)
        if (i >= this.databoxes.approvedPerBranch.limit) return;
      this.data.approvedPerBranch.labels.push(element.branch.title);
      this.data.approvedPerBranch.datasets.data.push(element.approved);
      i++;
    });

    i = 0;
    newVal.requestsOarPerBusiness.forEach((element) => {
      if (this.databoxes.requestsOarPerBusiness.limit !== -1)
        if (i >= this.databoxes.requestsOarPerBusiness.limit) return;
      this.data.requestsOarPerBusiness.labels.push(element.companyName);
      this.data.requestsOarPerBusiness.datasets.data.push(element.contracts);
      i++;
    });

    i = 0;
    newVal.requestsOarPerBranch.forEach((element) => {
      if (this.databoxes.requestsOarPerBranch.limit !== -1)
        if (i >= this.databoxes.requestsOarPerBranch.limit) return;
      this.data.requestsOarPerBranch.labels.push(element.branchName);
      this.data.requestsOarPerBranch.datasets.data.push(element.contracts);
      i++;
    });

    i = 0;
    newVal.requestsCountPerBranch.forEach((element) => {
      if (this.databoxes.requestsCountPerBranch.limit !== -1)
        if (i >= this.databoxes.requestsCountPerBranch.limit) return;
      this.data.requestsCountPerBranch.labels.push(element.branchName);
      this.data.requestsCountPerBranch.datasets.data.push(element.count);
      i++;
    });

    this.data.requestsState.datasets.data.push(newVal.requestsApproved);
    this.data.requestsState.datasets.data.push(newVal.requestsPending);
    this.data.requestsState.datasets.data.push(newVal.requestsRejected);
    this.data.requestsState.labels.push('Activas');
    this.data.requestsState.labels.push('Pendientes');
    this.data.requestsState.labels.push('No Procesadas');

    i = 0;
    newVal.requestsOriginalGrossAonPerClient.forEach((element) => {
      if (this.databoxes.originalGrossAonPerClient.limit !== -1)
        if (i >= this.databoxes.originalGrossAonPerClient.limit) return;
      this.data.originalGrossAonPerClient.labels.push(
        element.subscriptor && element.subscriptor.companies[0].name
      );
      this.data.originalGrossAonPerClient.datasets.data.push(
        element.original_gross_aon
      );
      this.data.originalGrossAonPerClient.datasets.backgroundColor.push(
        '#EC9300'
      );
      i++;
    });

    i = 0;
    newVal.requestsOriginalGrossAonPerBranch.forEach((element) => {
      if (this.databoxes.originalGrossAonPerBranch.limit !== -1)
        if (i >= this.databoxes.originalGrossAonPerBranch.limit) return;
      this.data.originalGrossAonPerBranch.labels.push(element.branch.title);
      this.data.originalGrossAonPerBranch.datasets.data.push(
        element.original_gross_aon
      );
      this.data.originalGrossAonPerBranch.datasets.backgroundColor.push(
        '#EC9300'
      );
      i++;
    });

    this.data.lastOperations = newVal.requestsLastOperations.map((req) => ({
      operation: req.content,
      nombre:
        (req.admin && req.admin.fullname) ||
        (req.subscriptor && req.subscriptor.fullname),
      fecha: moment(req.createdAt).format('DD/MM/YYYY'),
    }));

    this.currencies = newVal.allCurrencies;
    this.dates = newVal.allDates;
  }

  toggleShowMoreRequestsGraphs() {
    this.showMoreRequestsGraphs = !this.showMoreRequestsGraphs;

    if (this.showMoreRequestsGraphs)
      this.showMoreLabel = 'Ocultar reportes de clientes y ramos';
    else this.showMoreLabel = 'Ver reportes de clientes y ramos';
  }

  async toggleExpand(index) {
    this.databoxes[index].isExpanded = !this.databoxes[index].isExpanded;
    if (this.databoxes[index].isExpanded) {
      this.databoxes[index].limit = -1;
      this.databoxes[index].svgPath = this.iconCollapsed;
    } else {
      this.databoxes[index].limit = 4;
      this.databoxes[index].svgPath = this.iconExpanded;
    }

    this.resetData();
    await this.initGraphs(this.GraphsData);
  }

  graphFilters() {
    this.requestsFilters(this.requestsGraphFilters);
    this.resetData();
  }

  totalData(data) {
    let total = data.reduce((acc, val) => acc + val);
    total = total.toString();
    total = total.split(/(?=(?:...)*$)/);
    total = total.join('.');
    return total
  }
}
